<template lang="pug">
el-table(:data="formattedChangelogs")
  el-table-column(type="expand")
    template(#default="scope")
      .new-item.p-6.ml-8
        p(v-if="scope.row.changeType === 'NEW'") {{ $t("assetCreated") }}
        smx-form(
          v-else-if="scope.row.changeType === 'UPDATE' && scope.row.comment === 'initial edit'"
        )
          smx-form-item(:label="$t('name')")
            p.whitespace-pre-wrap {{ scope.row.snapshotAfter.name }}
          smx-form-item(:label="$t('description')")
            p.whitespace-pre-wrap {{ scope.row.snapshotAfter.description }}
          smx-form-item(
            v-for="prop in scope.row.snapshotAfter.properties",
            :key="prop.uuid",
            :label="prop.name"
          )
            p.whitespace-pre-wrap {{ prop.propertyValue !== undefined ? prop.propertyValue.value : "-" }}
        div(v-else-if="scope.row.propertyChanges !== undefined")
          .new-properties-grid
            template(
              v-for="change in scope.row.propertyChanges",
              :key="change.id"
            ) 
              label.smx-label {{ change.name }}
              s.text-rose-800 {{ change.oldValue ? change.oldValue : "-" }}
              span.text-green-600(class="max-md:mb-4") {{ change.value }}
          //- el-table.w-full(:data="scope.row.propertyChanges")
          //-   el-table-column(:label="$t('name')" prop="name")
          //-   el-table-column(:label="$t('oldValue')" prop="oldValue")
          //-   el-table-column(:label="$t('newValue')" prop="value")

  el-table-column(v-if="showName", :label="$t('name')", prop="name")
  el-table-column(:label="$t('changeType')", prop="changeType")
  el-table-column(
    :label="$t('changedAt')",
    prop="changedAt",
    :formatter="changedAtFormatter"
  )
  el-table-column(v-if="mq.mdPlus", :label="$t('changedBy')", prop="changedBy")
    template(#default="scope")
      UsersField(:user-ids="[scope.row.changedBy]")
  el-table-column(
    v-if="mq.mdPlus",
    :label="$t('changedReason')",
    prop="comment"
  )
</template>

<script setup lang="ts">
import { computed } from "vue";
import { type TwinChangelog } from "../../../services/twinData";
import { useMq } from "vue3-mq";
import { useI18n } from "vue-i18n";
import { formatDateTime } from "@shared/util/formatting";
import UsersField from "@shared/components/twinManagement/components/UsersField.vue";

const props = defineProps<{
  changelogs: TwinChangelog[];
  showName?: boolean;
}>();

const mq = useMq();

const { t } = useI18n();

const formattedChangelogs = computed(() =>
  props.changelogs.map((log) => {
    if (log.changeType === "UPDATE") {
      const propertyDiff = log.diff?.changes?.find(
        (item) => item.key === "properties",
      );

      const propertyChanges = propertyDiff
        ? propertyDiff.changes?.map((diff) => {
            // Find the name of the property
            const property = log.snapshotAfter.properties.find(
              (prop) => prop.uuid === diff.key,
            );
            // if (diff.type === "UPDATE") {

            // }
            // Find changes in propertyValue
            const propertyValueDiff = diff.changes?.find(
              (change) => change.key === "propertyValue",
            );
            const valueDiff =
              propertyValueDiff?.type === "UPDATE"
                ? propertyValueDiff?.changes?.find(
                    (item) => item.key === "value",
                  )
                : propertyValueDiff?.value;
            return {
              id: property?.uuid,
              name: property?.name,
              oldValue: valueDiff?.oldValue,
              value: valueDiff?.value,
            };
          })
        : [];

      // Name and description are handled like properties
      const nameChange = log.diff?.changes?.find(
        (change) => change.key === "name",
      );
      if (nameChange) {
        propertyChanges.push({
          id: "name",
          name: t("name"),
          oldValue: nameChange.oldValue,
          value: nameChange.value,
        });
      }

      const descriptionChange = log.diff?.changes?.find(
        (change) => change.key === "description",
      );
      if (descriptionChange) {
        propertyChanges.push({
          id: "description",
          name: t("description"),
          oldValue: descriptionChange.oldValue,
          value: descriptionChange.value,
        });
      }

      return {
        propertyChanges: propertyChanges,
        ...log,
      };
    }
    return {
      ...log,
    };
  }),
);

function changedAtFormatter(row: TwinChangelog) {
  return formatDateTime(row.changedAt);
}
</script>

<style>
.new-properties-grid {
  display: grid;
  grid-template-columns: min-content min-content min-content;
  row-gap: 1rem;
  column-gap: 1rem;
  white-space: nowrap;
}

@media only screen and (max-width: 768px) {
  .new-properties-grid {
    grid-template-columns: 1fr;
    row-gap: 0.5rem;
    white-space: normal;
  }
}
</style>
